import * as PIXI from "pixi.js";
import { Coord, GridConfig } from "../../../../../../../src/types/Interface";
import { QuestionType, ShapeType } from "../../../types/Enum";


export default class QuestionFactory {
  static addDescConfig(questionDesc: PIXI.Text, gridConfig: GridConfig) {
    questionDesc.style = {
      wordWrap: true,
      wordWrapWidth: gridConfig.width
    };
    const coord = {
      x: gridConfig.x - gridConfig.width / 2,
      y: gridConfig.y - gridConfig.height / 2 - 50
    }
    Object.assign(questionDesc, coord);
  }
  static getEmptyQuestion() {
    return {
      qType: QuestionType.TYPE1,
      desc: "",
      shapeType: ShapeType.l,
      shapePoints: [] as Coord[],
      rotatedShapePoints: [] as Coord[],
      centerPoint: {} as Coord,
      pivotPoint: {} as Coord,
      origin: {} as Coord,
      rotation: 0,
    }
  }
}